import React from 'react'
import classes from './Form.scss'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'

const form = ({ form, inputChanged, edit }) => {
  let data = Object.entries(form).map(item => {
    let [key, attr] = item
    if (key === 'criteria_name') {
      return (
        <InputGroup
          key={key}
          label={attr.label}
          inputType={attr.elementType}
          configs={{ ...attr.elementConfig, onBlur: e => inputChanged(key, e, true) }}
          invalid={!attr.valid}
          validations={attr.validation}
          touched={attr.touched}
          changed={e => inputChanged(key, e, false)}
          inputValue={attr.value}
          validationError={attr.error}
        />
      )
    } else if (key === 'appraisal_type_id') {
      return (
        <InputGroup
          key={key}
          label={attr.label}
          inputType={attr.elementType}
          configs={{ ...attr.elementConfig, disabled: edit }}
          invalid={!attr.valid}
          validations={attr.validation}
          touched={attr.touched}
          changed={e => inputChanged(key, e, true)}
          inputValue={attr.value}
          validationError={attr.error}
        />
      )
    } else {
      return (
        <InputGroup
          key={key}
          label={attr.label}
          inputType={attr.elementType}
          configs={{ ...attr.elementConfig }}
          invalid={!attr.valid}
          validations={attr.validation}
          touched={attr.touched}
          changed={e => inputChanged(key, e, true)}
          inputValue={attr.value}
          validationError={attr.error}
        />
      )
    }
  })
  return <div className={classes.Form}>{data}</div>
}

export default form
